// Ein modaler Dialog: eigene Überschrift, `aria-modal`, gefangener Fokus. Die Falle (Tabulator
// bleibt drinnen, Escape schließt, der Fokus kehrt zum Auslöser zurück) steckt vollständig in
// useFokusfalle — hier steht nur noch, woran sie hängt. Einen eigenen Escape-Handler hat dieser
// Baustein deshalb nicht mehr: zwei Handler schlössen den Dialog zweimal.
import { useRef, useId, type ReactElement, type ReactNode } from 'react'
import { useFokusfalle } from './useFokusfalle'
import './bausteine.css'

export interface DialogProps {
  offen: boolean
  titel: string
  onSchliessen: () => void
  children: ReactNode
}

export function Dialog({ offen, titel, onSchliessen, children }: DialogProps): ReactElement | null {
  const kasten = useRef<HTMLDivElement>(null)
  const titelId = useId()
  useFokusfalle(kasten, offen, onSchliessen)

  if (!offen) return null

  return (
    <div className="dialog-hintergrund">
      <div ref={kasten} className="dialog" role="dialog" aria-modal="true" aria-labelledby={titelId}>
        <h2 id={titelId}>{titel}</h2>
        {children}
      </div>
    </div>
  )
}
